import { copyObjectGraph, exportObjectTreeGraph, GRAPH_COPY_OFFSET, placeComponentGraph } from '../graph/graphClipboard.js';
import { extractObjectsLogic, LOGIC_ID_PREFIX } from './logicGraph.js';
import { deserializeLogicGraph, serializeLogicGraph } from './logicSerialization.js';

// Copies are placed next to the original, like the copied objects themselves.
export const LOGIC_COPY_OFFSET = GRAPH_COPY_OFFSET;

// The event/action graph for the generic graph clipboard (graph/graphClipboard.js).
const LOGIC_CLIPBOARD = Object.freeze({
    graphKey: 'logic',
    extract: extractObjectsLogic,
    idPrefix: LOGIC_ID_PREFIX,
    serialize: serializeLogicGraph,
    deserialize: deserializeLogicGraph,
});

/**
 * Duplicate the event/action nodes of copied objects onto the copies' page
 * (see copyObjectGraph). Returns unpushed history commands.
 */
export function copyObjectLogic(layer, uuidMap, logicStore, { getPage, offset = LOGIC_COPY_OFFSET }) {
    return copyObjectGraph(layer, uuidMap, logicStore, LOGIC_CLIPBOARD, { getPage, offset, description: 'Copy logic' });
}

/** File-form logic of an object subtree for a custom component (see exportObjectTreeGraph). */
export function exportObjectTreeLogic(root, getPage) {
    return exportObjectTreeGraph(root, getPage, LOGIC_CLIPBOARD);
}

/** Add a custom component's file-form logic to `page` (see placeComponentGraph). */
export function placeComponentLogic(page, logic, uuidOfComponentId, offset = { x: 0, y: 0 }) {
    return placeComponentGraph(page, logic, uuidOfComponentId, offset, LOGIC_CLIPBOARD);
}
